var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M12 0C5.373 0 0 5.298 0 11.833c0 6.536 5.373 11.834 12 11.834s12-5.298 12-11.834C24 5.298 18.627 0 12 0zM5.76 9.801h2.72v8.057H5.76V9.801zm2.9-2.493c-.018-.79-.591-1.391-1.521-1.391-.93 0-1.539.601-1.539 1.391 0 .774.59 1.393 1.503 1.393h.018c.948 0 1.538-.619 1.538-1.393zm6.497 2.304c1.79 0 3.13 1.152 3.13 3.627v4.62h-2.719v-4.311c0-1.083-.393-1.822-1.378-1.822-.751 0-1.198.498-1.395.98-.072.172-.09.412-.09.653v4.5h-2.72s.036-7.302 0-8.058h2.72v1.142c.361-.55 1.008-1.331 2.452-1.331z"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
